module.exports = __webpack_public_path__ + "img/L1060499.325c1f44.jpg";